import { Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from '../components/routes/ProtectedRoute';
import KbOnboardingModal from '../components/global/KbOnboardingModal';
import AuthLoginPage from '../pages/auth/login';
import AuthRegisterPage from '../pages/auth/register';
import AuthRegisterTermsPage from '../pages/auth/register-terms';
import AuthLoginEmailPage from '../pages/auth/login-email';
import KakaoAuthPage from "../pages/auth/kakao";
import GoogleAuthPage from '../pages/auth/google';
import CalendarConnectedPage from '../pages/calendar/connected';
import CalendarGooglePage from '../pages/calendar/google';
import GoogleCalendarCallbackPage from '../pages/calendar/google-calendar-callback';
import OverviewPage from '../pages/overview/index';
import StoresPage from '../pages/stores/index';
import StoreChannelsPage from '../pages/stores/channels';
import CallLogsPage from '../pages/stores/call-logs';
import KnowledgeBasesPage from '../pages/stores/knowledge-bases';
import MenusPage from '../pages/stores/menus';
import NotificationsPage from '../pages/stores/notifications';
import StorePromptPage from '../pages/stores/prompt';
import StoreInfoPage from '../pages/stores/store-info';
import ChannelDetailPage from '../pages/stores/channel';
import CalendarOnboardingPage from '../pages/stores/calendar-onboarding';
import DashboardLayout from '../components/layouts/DashboardLayout';
import OnboardingPage from '../pages/onboarding/index';
import FaqOnboardingPage from '../pages/onboarding/faq';
import LandingPage from '../pages/landing';


const AppRoutes = () => {
    return (
        <>
        <KbOnboardingModal />
        <Routes>
            {/* 인증 불필요 */}
            <Route path="/" element={<Navigate to="/auth/login" replace />}/>
            <Route path="/landing" element={<LandingPage/>}/>
            <Route path="/auth/login" element={<AuthLoginPage />} />
            <Route path="/auth/register" element={<AuthRegisterPage />} />
            <Route path="/auth/register/terms" element={<AuthRegisterTermsPage />} />
            <Route path="/auth/login/email" element={<AuthLoginEmailPage />} />
            <Route path="/auth/kakao" element={<KakaoAuthPage />} />
            <Route path="/auth/google" element={<GoogleAuthPage />} />
            <Route path="/calendar/google" element={<CalendarGooglePage />} />
            <Route path="/accounts/me/calendar/google/callback" element={<GoogleCalendarCallbackPage />} />
            <Route path="/calendar/connected" element={<CalendarConnectedPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/onboarding/faq" element={<FaqOnboardingPage />} />

            {/* 로그인 + 온보딩 완료 필요 */}
            {/* <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} /> */}
            <Route path="/overview" element={<ProtectedRoute><DashboardLayout><OverviewPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores" element={<ProtectedRoute><DashboardLayout><StoresPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout><StoresPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid" element={<ProtectedRoute><DashboardLayout><StoreInfoPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/store-info" element={<ProtectedRoute><DashboardLayout><StoreInfoPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/channels" element={<ProtectedRoute><DashboardLayout><StoreChannelsPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/channels/:channelUuid" element={<ProtectedRoute><DashboardLayout><ChannelDetailPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/channels/:channelUuid/calendar-onboarding" element={<ProtectedRoute><CalendarOnboardingPage /></ProtectedRoute>} />
            <Route path="/stores/:uuid/channels/:channelUuid/calls" element={<Navigate to="/stores" replace />} />
            <Route path="/stores/:uuid/call-logs" element={<ProtectedRoute><DashboardLayout><CallLogsPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/menus" element={<ProtectedRoute><DashboardLayout><MenusPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/notifications" element={<ProtectedRoute><DashboardLayout><NotificationsPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/knowledge-bases" element={<ProtectedRoute><DashboardLayout><KnowledgeBasesPage /></DashboardLayout></ProtectedRoute>} />
            <Route path="/stores/:uuid/prompt" element={<ProtectedRoute><DashboardLayout><StorePromptPage /></DashboardLayout></ProtectedRoute>} />
        </Routes>
        </>
    );
};

export default AppRoutes;
